/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/glass/controllers/ShareController',['underscore', '../../lib/@waca/baglass/js/baglass/app/plugins/ButtonActionInterface', '../utils/GlassUtil', '../utils/ReactBridge', '../../nls/StringResources'], function (_, ButtonActionInterface, GlassUtil, ReactBridge, StringResources) {
	'use strict';

	var feature = GlassUtil.feature,
	    featuresForPerspective = GlassUtil.featuresForPerspective;


	function getFeatures(context) {
		var plugin = context.target.plugin,
		    _plugin$itemSpec = plugin.itemSpec,
		    _plugin$itemSpec$item = _plugin$itemSpec.items,
		    items = _plugin$itemSpec$item === undefined ? [] : _plugin$itemSpec$item,
		    _plugin$itemSpec$opti = _plugin$itemSpec.options,
		    options = _plugin$itemSpec$opti === undefined ? {} : _plugin$itemSpec$opti,
		    _options$features = options.features,
		    features = _options$features === undefined ? [] : _options$features,
		    results = _.intersection(features, featuresForPerspective(items));


		return results;
	}

	var ShareController = ButtonActionInterface.extend({

		init: function init(options) {
			ShareController.inherited('init', this, arguments);

			this.ActionHandler = options && options.ActionHandler || ReactBridge;
			this.isDialogShown = false;
		},

		onRender: function onRender(context) {
			var plugin = context.target.plugin;

			var features = this._getFeatures(context);

			// if any features are available, we can display the Share button
			if (features.length > 0) {
				plugin.show();
			} else {
				plugin.hide();
			}
		},

		onSelectItem: function onSelectItem(context) {
			return this._performAction(context);
		},

		/**
   * A callback that is called after the slideout opens.
   * @override
   * @returns {boolean} if the dialog was shown or not
   */
		onPress: function onPress(context) {
			return this._performAction(context);
		},

		_getFeatures: function _getFeatures(context) {
			if (!this.features) {
				this.features = getFeatures(context);
			}
			return this.features;
		},

		_performAction: function _performAction(context) {
			var _this = this;

			var features = this._getFeatures(context);

			var embedVisible = features.indexOf(feature.EMBED) !== -1;

			if (!this.isDialogShown) {
				var bridge = new this.ActionHandler({
					glassContext: context.glassContext,
					embedVisible: embedVisible,
					features: features,
					onClose: function onClose() {
						return _this.isDialogShown = false;
					}
				});
				this.isDialogShown = true;

				bridge.execute().catch(function (err) {
					_this.isDialogShown = false;
					context.glassContext.showToast(StringResources.get('error_unknown', { error: err.message }), { type: 'error' });
					var logger = context.glassContext.getCoreSvc('.Logger');
					logger.error(err);
				});
				return true;
			}
			return false;
		}

	});

	return ShareController;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

